import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import fetchApi from '../utils/api.js';
import { usePermissionContext } from '../contexts/PermissionContext';
import Swal from 'sweetalert2';

function VoucherTypeForm() {
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const isEdit = !!id;

    const [voucherTypeName, setVoucherTypeName] = useState('');
    const [loading, setLoading] = useState(false);
    const { fetchVouchers } = usePermissionContext();

    useEffect(() => {
        if (isEdit) {
            if (location.state && location.state.type) {
                setVoucherTypeName(location.state.type.voucherTypeName);
            } else {
                fetchVoucherType();
            }
        }
    }, [id]);

    const fetchVoucherType = async () => {
        try {
            setLoading(true);
            const result = await fetchApi(`/voucher-type/${id}`);
            if (result) {
                setVoucherTypeName(result.voucherTypeName);
            }
        } catch (error) {
            console.error('Error fetching voucher type:', error);
            toast.error('Failed to load voucher type details');
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {

    if(e) e.preventDefault();
    const conf = await Swal.fire({
      title: 'Save Data?',
      text: 'Are you sure you want to save this data?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#00334e',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Save',
      cancelButtonText: 'No, Keep Editing'
    });
    if(!conf.isConfirmed) return;
        e.preventDefault();
        const trimmedName = voucherTypeName.trim();

        if (!trimmedName) {
            toast.error("Voucher Type name cannot be empty");
            return;
        }

        const defaultVoucherTypes = ["Kasar Payment", "Cash Receipt", "cash payment", "Bank Receipt", "Bank Payment"];
        if (defaultVoucherTypes.some(d => d.toLowerCase() === trimmedName.toLowerCase())) {
            toast.error("This is a system default voucher type and cannot be manually created or modified");
            return;
        }

        try {
            setLoading(true);
            const payload = { voucherTypeName: trimmedName };
            
            await fetchApi(isEdit ? `/voucher-type/${id}` : '/voucher-type', {
                method: isEdit ? 'PUT' : 'POST',
                body: JSON.stringify(payload)
            });

            // Refresh sidebar vouchers
            await fetchVouchers();

            const user = JSON.parse(sessionStorage.getItem('user'));
            const rolePrefix = user?.role === 'SUPER_ADMIN' ? '/super-admin' : (user?.role === 'ADMIN' ? '/admin' : '/user');

            toast.success(isEdit ? 'Voucher Type updated!' : 'Voucher Type added!');
            navigate(`${rolePrefix}/settings/voucher-type`);
        } catch (error) {
            console.error('Error saving voucher type:', error);
            toast.error(error.message || 'Failed to save voucher type');
        } finally {
            setLoading(false);
        }
    };

    const user = JSON.parse(sessionStorage.getItem('user'));
    const rolePrefix = user?.role === 'SUPER_ADMIN' ? '/super-admin' : (user?.role === 'ADMIN' ? '/admin' : '/user');

    return (
        <div className="list-page-container">
            <div className="list-page-header">
                <h1 className="list-page-title">{isEdit ? 'Update Voucher Type' : 'Add Voucher Type'}</h1>
            </div>

            <div style={{ 
                padding: '24px',
                background: '#fff',
                borderRadius: '8px',
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                marginTop: '20px'
            }}>
                <form onSubmit={handleSubmit}>
                    <div style={{ 
                        display: 'grid',
                        gridTemplateColumns: '1fr',
                        gap: '24px',
                        marginBottom: '24px'
                    }}>
                        <div style={{ 
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '8px'
                        }}>
                            <label style={{ 
                                fontSize: '14px',
                                fontWeight: '600',
                                color: '#374151'
                            }}>
                                VOUCHER NAME
                            </label>
                            <input
                                type="text"
                                style={{ 
                                    padding: '12px',
                                    border: '1px solid #d1d5db',
                                    borderRadius: '8px',
                                    fontSize: '14px',
                                    outline: 'none',
                                    width: '100%',
                                    boxSizing: 'border-box'
                                }}
                                placeholder="Enter voucher type name"
                                value={voucherTypeName}
                                onChange={(e) => setVoucherTypeName(e.target.value)}
                                required
                            />
                        </div>
                    </div>

                    <div style={{ 
                        display: 'flex',
                        justifyContent: 'flex-end',
                        gap: '16px',
                        marginTop: '32px',
                        paddingTop: '24px',
                        borderTop: '1px solid #f3f4f6'
                    }}>
                        <button 
                            type="button" 
                            style={{ 
                                backgroundColor: '#ffeff0',
                                color: '#ef4444',
                                padding: '12px 32px',
                                border: 'none',
                                borderRadius: '8px',
                                fontWeight: '600',
                                cursor: 'pointer',
                                fontSize: '15px'
                            }}
                            onClick={() => navigate(`${rolePrefix}/settings/voucher-type`)}
                        >
                            Cancel
                        </button>
                        <button 
                            type="submit" 
                            style={{ 
                                backgroundColor: '#0b3a54',
                                color: '#fff',
                                padding: '12px 32px',
                                border: 'none',
                                borderRadius: '8px',
                                fontWeight: '600',
                                cursor: 'pointer',
                                fontSize: '15px'
                            }}
                            disabled={loading}
                        >
                            {loading ? "Saving..." : "Submit"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default VoucherTypeForm;
